require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-planning-social-channel-audit.json") })
        }
      }, "path---services-planning-social-channel-audit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-planning-social-channel-audit!./.cache/json/services-planning-social-channel-audit.json
// module id = 775
// module chunks = 231608221292675